/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-22 10:35:51
 * @LastEditTime: 2020-11-23 11:18:50
 */
import { getuser_iscustomer, getuser_ctid } from "@/localStorage/localStorage";
import i18n from "@/common/lang";
export const rules = {
  username: [
    { required: true, message: i18n.t('lang.usercontrol.errmessage1'), trigger: 'blur'}
  ],
  password: [
    { required: true, validator: VerificationPassword, trigger: 'blur', message: i18n.t('lang.usercontrol.errmessage7') }
  ],
  roleid: [
    { required: true, message: i18n.t('lang.usercontrol.selectRoleTips'), trigger: ['blur', 'change'] }
  ],
  user_iscustomer: [
    { required: true, message: i18n.t('lang.usercontrol.selectCustomerTips'), trigger: ['blur', 'change'] }
  ],
  user_tel: [
    { required: true, message: i18n.t('lang.usercontrol.selectTelTips'), trigger: 'blur' }
  ],
  user_email:[
    { required: true, message: i18n.t('lang.usercontrol.selectTelTips'), trigger: 'blur' }
  ]
}
export var VerificationPassword = (rule, value, callback) => {
  let password = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,16}$/;
  if(password.test(value) == false){
    return callback(new Error(i18n.t('lang.usercontrol.errmessage7')))
  }else {
    callback()
  }
}

export const setLevel = function() {
  let userlevel = []
  if (getuser_iscustomer() == 2) {
    userlevel = [
      { value: i18n.t("lang.usercontrol.usertype3"), label: i18n.t("lang.usercontrol.usertype3")},
      { value: i18n.t("lang.usercontrol.usertype1"), label: i18n.t("lang.usercontrol.usertype1")}
    ];
  }
  if (getuser_iscustomer() == 1 && getuser_ctid() == 0) {
    userlevel = [
      { value: i18n.t("lang.usercontrol.usertype1"), label: i18n.t("lang.usercontrol.usertype1")}
    ];
  }
  if (getuser_iscustomer() == 1 && getuser_ctid() != 0) {
    userlevel = [
      { value: i18n.t("lang.usercontrol.usertype1"), label: i18n.t("lang.usercontrol.usertype1")}
    ];
  }
  return userlevel
}